import React, { useState } from "react";
import Header from "../components/Header";

const Concrete = () => {
  const [selectedOption, setSelectedOption] = useState('concrete');
  const [length, setLength] = useState(0);
  const [breadth, setBreadth] = useState(0);
  const [thickness, setWidth] = useState(0);
  const [cementRatio, setCementRatio] = useState(0);
  const [sandRatio, setSandRatio] = useState(0);
  const [aggRatio, setAggRatio] = useState(0);
  const [result, setResult] = useState('');
  const [showResult, setShowResult] = useState(false);

  const densityofCement = 1440;
  const densityofSand=parseFloat(1600);
  const densityofAgg=parseFloat(1500);
  const bagOfCement = 50;

  const volumeOfOnecmCubeConcrete = 1.54;

  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
    setResult('');
    setShowResult(false);
  };

  const calculateConcrete = () => {
     if (!length || !breadth ||  !thickness || !cementRatio || !sandRatio || !aggRatio){
      alert(" Please fill all the fields");
      return;
    }
 
    const cLength = parseFloat(length);
    const cBreadth = parseFloat(breadth);
    const cWidth = parseFloat(thickness);
    const cCement = parseFloat(cementRatio);
    const cSand = parseFloat(sandRatio);
    const cAggregate = parseFloat(aggRatio);

       if (
      isNaN(cLength) || isNaN(cBreadth) || isNaN(cWidth) ||
      isNaN(cCement) || isNaN(cSand) || isNaN(cAggregate)
    ) {
      alert("Please enter valid numerical values for all concrete inputs.");
      return;
    }

    const volume = cLength * cBreadth * cWidth;
    const totalRatio = cCement + cSand + cAggregate;


    const cementVolume = (volumeOfOnecmCubeConcrete / totalRatio) * cCement;
    const sandVolume = (volumeOfOnecmCubeConcrete / totalRatio) * cSand;
    const aggregateVolume = (volumeOfOnecmCubeConcrete / totalRatio) * cAggregate;

    const cementMass =   cementVolume * volume;
    const cementBagsPerM3 =  cementMass * densityofCement;
    const totalCementBags =  cementBagsPerM3/ bagOfCement;

    const middleSandVolume = sandVolume * volume;
    const totalSandVolume = (densityofSand *middleSandVolume)/1000;

    const middleAggregateVolume = aggregateVolume * volume;
const totalAggregateVolume = (densityofAgg * middleAggregateVolume)/1000;

  const dryConcrete =  cementMass + middleSandVolume + middleAggregateVolume;

    setResult({
      volume : volume.toFixed(2),
      dryConcrete:dryConcrete.toFixed(2),
      totalCementBags: totalCementBags.toFixed(2),
      totalSandVolume: totalSandVolume.toFixed(2),
      
      totalAggregateVolume: totalAggregateVolume.toFixed(2)
      
    });

    setShowResult(true);
  };

  const calculateMortar = () => {
     if (!length || !breadth ||  !thickness || !cementRatio || !sandRatio){
      alert(" Please fill all the fields");
      return;
    }
   
    const volume = parseFloat(length) * parseFloat(breadth) * parseFloat(thickness);
    const cementR = parseFloat(cementRatio);
    const sandR = parseFloat(sandRatio);
  if (isNaN(volume) || isNaN(cementR) || isNaN(sandR)) {
      alert("Please enter valid numerical values for all mortar inputs.");
      return;
    }
    

    const cementRCalculate = (volumeOfOnecmCubeConcrete / (cementR + sandR)) * cementR;
    const sandRCalculate = (volumeOfOnecmCubeConcrete / (cementR + sandR)) * sandR;

    const cementMass = cementRCalculate  * volume;
    const mainKgForOnecmCube = cementMass  * densityofCement;
    const totalCementBags = mainKgForOnecmCube/ bagOfCement;

    const halfSandVolume = volume * sandRCalculate;
    const totalSandVolume = (halfSandVolume * densityofSand)/1000;
 const dryMortar = cementMass + halfSandVolume;

    setResult({
      volume: volume.toFixed(2),
      dryMortar:dryMortar.toFixed(2),
      totalCementBags: totalCementBags.toFixed(2),
      totalSandVolume: totalSandVolume.toFixed(2)

    });

    setShowResult(true);
  };

  return (
    <div className="container">
<Header/>
      <main className="content">
        <div className="estimation-container">
          <fieldset className="toggle-container">
            <legend>Concrete Estimation</legend>
            <input type="radio" name="estimationType" value="concrete" checked={selectedOption === 'concrete'} onChange={handleRadioChange} />
            <label htmlFor="concrete"> Concrete </label>
            <input type="radio" name="estimationType" value="mortar" checked={selectedOption === 'mortar'} onChange={handleRadioChange} />
            <label htmlFor="mortar"> Mortar </label>
          </fieldset>

          {selectedOption === 'concrete' && (
            <fieldset className="concreteForm">
              <h3>Concrete Estimation</h3>
              <label>Length (m):</label>
              <input type="number" onChange={(e) => setLength(e.target.value)} />
              <label>Breadth (m):</label>
              <input type="number" onChange={(e) => setBreadth(e.target.value)} />
              <label>Thickness (m):</label>
              <input type="number" onChange={(e) => setWidth(e.target.value)} />

            <label style={{ marginTop:"10px"}}><b>Cement Sand Aggregate Mix Ratio </b></label>
              <div  style={{ display: "flex", justifyContent: "center", gap: "20%" }}>
                <label htmlFor="cementR">Cement:</label>
                <label htmlFor="sandR">Sand:</label>
                <label htmlFor="aggR">Aggregate:</label>
              </div>
              <div  style={{ display: "flex", justifyContent: "center", gap: "10%" }}>
                <input id="cementR" type="number" placeholder="e.g 1" onChange={(e) => setCementRatio(e.target.value)} />
                <input id="sandR" type="number" placeholder="e.g 2" onChange={(e) => setSandRatio(e.target.value)} />
                <input id="aggR" type="number" placeholder="e.g 4" onChange={(e) => setAggRatio(e.target.value)} />
              </div>

              <button onClick={calculateConcrete}>Submit</button>
            </fieldset>
          )}

          {selectedOption === 'mortar' && (
            <fieldset>
              <h3>Mortar Estimation</h3>
              <label>Length (m):</label>
              <input type="number" onChange={(e) => setLength(e.target.value)} />
              <label>Breadth (m):</label>
              <input type="number" onChange={(e) => setBreadth(e.target.value)} />
              <label>Thickness (m):</label>
              <input type="number" onChange={(e) => setWidth(e.target.value)} />

                 <label style={{ marginTop:"10px"}}><b>Cement Sand Mix Ratio </b></label>
             <div style={{ display: "flex", justifyContent: "center", gap: "40%" }}>
              <label>Sand:</label>
              <label>Cement:</label>
              </div> 
              <div style={{ display: "flex", justifyContent: "center", gap: "30%" }}>
                <input type="number" placeholder="E.g., 1" onChange={(e) => setCementRatio(e.target.value)} />
                
                <input type="number" placeholder="E.g., 3" onChange={(e) => setSandRatio(e.target.value)} />
              </div>

              <button onClick={calculateMortar}>Submit</button>
            </fieldset>
          )}
        </div>
      </main>

      {/* Result Popup */}
      {showResult && (
        <div className="result-wrapper" onClick={() => setShowResult(false)}>
          <div className="result-display" onClick={(e) => e.stopPropagation()}>
            <div className="close-result" onClick={() => setShowResult(false)}>X</div>
            {selectedOption === 'concrete' ? (
              <div>
              <p>Volume of Wet Concrete: {result.volume} m³</p>
              <p>Volume of Dry Concrete: {result.dryConcrete} m³</p>
                <p>Cement: {result.totalCementBags} bag/bags</p>
                <p>Sand: {result.totalSandVolume}  tonne/tonnes</p>
                
                <p>Aggregate: {result.totalAggregateVolume} tonne/tonnes </p>
                
              </div>
            ) : (
              <div>
                 <p>Volume of Wet Mortar: {result.volume} m³ </p>
              <p>Volume of Dry Mortar: {result.dryMortar} m³</p>
                <p>Cement: {result.totalCementBags} bag/bags</p>
                <p>Sand: {result.totalSandVolume} tonne/tonnes</p>
                
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Concrete;
